<div class="navigation-div">
    <mat-toolbar color="primary" class="d-flex justify-content-between">
        <button mat-icon-button aria-label="home" (click)="onHomeClick()" style="margin-left: -12px">
            <mat-icon class="white">home</mat-icon>
        </button>
        <button mat-icon-button aria-label="close menu" (click)="layoutService.toggleNavigation()">
            <mat-icon class="white">chevron_left</mat-icon>
        </button>
    </mat-toolbar>
    <div class="flex-column">
        @if (appMenu && filteredMenuItems !== undefined) {
            <mat-nav-list #menuList>
                @for (menuItem of filteredMenuItems; track menuItem.ID) {
                    @if ($first) {
                        <mat-list-item
                            id="main-menu"
                            (click)="setMenu(0)"
                            animate.enter="menu-item-enter"
                            class="menu-slide-from-right">
                            <mat-icon matListItemIcon class="text-secondary no-margin">apps</mat-icon>
                            <div matListItemTitle>Main Menu</div>
                        </mat-list-item>
                    }
                    <mat-list-item
                        (click)="onMenuItemClick(menuItem)"
                        animate.enter="menu-item-enter"
                        class="menu-slide-from-right">
                        <mat-icon matListItemIcon class="text-secondary no-margin">{{ menuItem.Icon }}</mat-icon>
                        <div matListItemTitle>{{ menuItem.Name }}</div>
                    </mat-list-item>
                }
            </mat-nav-list>
        }
        @if (!appMenu && apps !== undefined) {
            <mat-nav-list multiple="false" #appsList>
                @for (app of apps; track app.ID) {
                    @if ($first) {
                        <mat-list-item
                            class="d-flex d-sm-none menu-slide-from-left"
                            id="home"
                            (click)="layoutService.closeNavigation(); router.navigate(['/mobile'])"
                            animate.enter="menu-item-enter">
                            <mat-icon matListItemIcon class="text-secondary no-margin">home</mat-icon>
                            <div matListIteTitle>Home</div>
                        </mat-list-item>
                    }
                    <mat-list-item
                        (click)="onApplicationClick(app)"
                        animate.enter="menu-item-enter"
                        class="menu-slide-from-left">
                        <mat-icon matListItemIcon class="text-secondary no-margin">{{ app.Icon }}</mat-icon>
                        <div matListItemTitle>{{ app.Name }}</div>
                    </mat-list-item>
                }
            </mat-nav-list>
        }
    </div>
</div>
